export function distributeStudents(studentIds, groups, requestedCount, shuffle = false, random = Math.random) {
  const count = Math.max(1, Math.min(Math.floor(Number(requestedCount) || 1), 100));
  const assignedGroups = Array.from({ length: count }, (_, index) => ({
    ...(groups[index] || {}),
    name: groups[index]?.name || `第${index + 1}組`,
    studentIds: []
  }));
  const students = [...studentIds];

  if (shuffle) {
    for (let index = students.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(random() * (index + 1));
      [students[index], students[randomIndex]] = [students[randomIndex], students[index]];
    }
  }

  students.forEach((studentId, index) => {
    assignedGroups[index % count].studentIds.push(studentId);
  });
  return assignedGroups;
}

export function moveStudentBetweenGroups(groups, studentId, targetIndex) {
  return groups.map((group, index) => {
    const studentIds = group.studentIds.filter((id) => Number(id) !== Number(studentId));
    if (index === targetIndex && targetIndex !== null) studentIds.push(Number(studentId));
    return { ...group, studentIds };
  });
}
